<template>
  <div>
    <q-form ref="editForm">
      <c-card title="순회점검계획 정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <!-- <c-btn
              v-show="disabled && editable"
              :url="cancelUrl"
              :isSubmit="isCancel"
              :param="place"
              mappingType="PUT"
              label="완료취소"
              icon="restart_alt"
              @beforeAction="cancelPlace"
              @btnCallback="cancelCallback" 
            />
            <c-btn
              v-show="!disabled && editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="place"
              mappingType="PUT"
              label="저장"
              icon="save"
              @beforeAction="savePlace"
              @btnCallback="saveCallback" 
            />
            <c-btn
              v-show="!disabled && editable"
              :url="completeUrl"
              :isSubmit="isComplete"
              :param="place"
              mappingType="PUT"
              label="완료"
              icon="check"
              @beforeAction="completePlace"
              @btnCallback="completeCallback" 
            /> -->
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <!-- <div class="col-xs-6 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-datepicker
              :editable="editable"
              :disabled="true"
              label="순회예정일"
              name="patrolScheduleDate"
              v-model="place.patrolScheduleDate"
            />
          </div> -->
          <div class="col-xs-6 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-datepicker
              :editable="editable && !disabled"
              label="순회일"
              name="patrolDate"
              v-model="place.patrolDate"
              @datachange="placeChange"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-multi-field
              :editable="editable"
              :disabled="true"
              label="점검자"
              type="user"
              name="checkUserId"
              v-model="patrol.checkUserId">
            </c-multi-field>
          </div>
        </template>
      </c-card>
        <!-- landscapeMode -->
      <c-table
        ref="table"
        title="순회 일상점검 Check-List"
        :gridHeightAuto="true"
        :columns="gridColumns"
        :gridHeight="gridHeight"
        :data="filterData"
        :merge="grid.merge"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :editable="editable && !disabled"
        @table-data-change="tableDataChange"
      >
        <template slot="table-header-append">
          <div class="slotAppentTitle">* 라인선택 </div>
          <c-select
            :comboItems="lineItems"
            type="none"
            itemText="lineCd"
            itemValue="lineId"
            name="lineCd"
            label=""
            v-model="lineId"
            @datachange="lineDatachange(false)"
          ></c-select>
        </template>
        <template slot="suffixTitle">
          <font class="text-negative" style="font-size:0.8em;font-weight:300;">
            양호(O) ,  불량(X) , 즉조치(△)
          </font>
        </template>
        <template v-slot:custom-label-after="{ col }">
          <div v-if="col.name==='saiEquipClassName'">
            <!-- 설비분류 -->
            <c-select
              stype="tableHeaderselect"
              :comboItems="equipComboItems"
              type="custom"
              typetxt="All"
              itemText="codeName"
              itemValue="code"
              v-model="filter.saiEquipClassName" />
          </div>
          <div v-if="col.name==='saiItemClassName'">
            <!-- 항목분류 -->
            <c-select
              stype="tableHeaderselect"
              :comboItems="itemComboItems"
              type="custom"
              typetxt="All"
              itemText="codeName"
              itemValue="code"
              v-model="filter.saiItemClassName" />
          </div>
        </template>
        <template v-slot:customArea="{ props }">
          <template>
            <q-btn
              flat
              size="12px"
              color="orange"
              icon="chevron_right"
              @click="rowClickDetail(props.row, props.pageIndex)" />
          </template>
        </template>
        <!-- <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <template v-else>
          </template>
          <div v-if="editable && Boolean(props.row.saiPatrolResultId) && props.row.editFlag !== 'C' && !disabled">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template> -->
      </c-table>
    </q-form>
    <q-dialog v-model="dialogDetail" :position="positionDetail">
      <q-card style="width: 100%">
        <q-linear-progress :value="1" color="pink" />
        <q-card-section class="row">
          <div class="col-12 text-weight-bold-dailog" v-text="selectedRow.patrolItemName"></div>
          <div class="col-4"><div class="mini-dailog-title">개선진행 상태</div></div>
          <div class="col-8 mini-dailog-btn-impr">
            <div v-if="editable && Boolean(selectedRow.saiPatrolResultId) && selectedRow.editFlag !== 'C' && !disabled">
              <q-btn-group outline>
                <c-btn
                  v-if="editable&&!disabled"
                  :showLoading="false"
                  label="개선요청"
                  color="red-6"
                  text-color="white"
                  @btnClicked="innerBtnClicked(selectedRow, '1')"
                />
                <c-btn
                  v-if="editable&&!disabled"
                  :showLoading="false"
                  label="즉시조치"
                  color="light-blue"
                  text-color="white"
                  @btnClicked="innerBtnClicked(selectedRow, '2')"
                />
              </q-btn-group>
            </div>
          </div>
          <div class="col-12 border-impr-dialog">
            <template v-if="selectedRow['sopImprovementIds'] && selectedRow['ibmStepNames']">
              <q-chip
                v-for="(item, index) in $comm.ibmTagItems(selectedRow, colorItems)"
                :key="index"
                :color="item.ibmClassCd === 'IC00000001' ? 'blue-6' : 'orange'"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click="linkClick(item, selectedRow)">
                {{item.title}}
                <!-- <c-assess-tooltip 
                  :ibmTooltip="item.ibmTooltip"
                  :ibmClassCd="item.ibmClassCd"
                /> -->
              </q-chip>
            </template>
            <template v-else>
              등록된 개선요청 및 즉시조치가 없습니다.
            </template>
          </div>
          <div class="col-12">&nbsp;
          </div>
          <div class="col-4">
            <div class="mini-dailog-title">요청사항</div>
          </div>
          <div class="col-12">
            <c-text
              :editable="editable && !disabled"
              label=""
              name="dialogpatrolContents"
              v-model="dialogpatrolContents">
            </c-text>
          </div>
          <div class="col-12 mini-dailog-btn-impr">
            <q-btn-group outline>
              <c-btn
                :showLoading="false"
                label="닫기"
                icon="close"
                @btnClicked="dialogClose"
              />
              <c-btn
                v-if="editable && !disabled"
                :showLoading="false"
                label="적용"
                icon="check"
                color="amber-7"
                @btnClicked="dialogSubmit"
              />
            </q-btn-group>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <div class="popup-bottom-bar">
      <div class="popup-bottom-bar-btngroup">
        <q-btn-group outline >  
          <c-btn
            :flat="true"
            v-show="disabled && editable"
            :url="cancelUrl"
            :isSubmit="isCancel"
            :param="place"
            mappingType="PUT"
            label="완료취소"
            icon="restart_alt"
            @beforeAction="cancelPlace"
            @btnCallback="cancelCallback" 
          />
          <c-btn
            :flat="true"
            v-show="!disabled && editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="place"
            mappingType="PUT"
            label="저장"
            icon="save"
            @beforeAction="savePlace"
            @btnCallback="saveCallback" 
          />
          <c-btn
            :flat="true"
            v-show="!disabled && editable"
            :url="completeUrl"
            :isSubmit="isComplete"
            :param="place"
            mappingType="PUT"
            label="완료"
            icon="check"
            @beforeAction="completePlace"
            @btnCallback="completeCallback" 
          />
        </q-btn-group>
      </div>
      <div class="popup-bottom-bar-close">
        <q-btn flat color="gray" icon="arrow_back" @click="closePopUps" />
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-place-result',
  props: {
    place: {
      type: Object,
      default: () => ({
        saiPatrolPlaceId: '',  // 순회점검 결과 장소 일련번호
        saiPatrolId: '',  // 순회점검 일련번호
        placeId: '',  // 장소번호
        patrolScheduleDate: '',  // 순회예정일
        patrolDate: '',  // 순회일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        userId: '',  // 점검부서 코드
        userName: '',  // 점검부서
        patrolPlaceStepCd: '',
        regUserId: '',  //
        resultMaps: [],
        results: [],
        lines: [],
      }),
    },
    patrol: {
      type: Object,
      default: () => {
        return {
          patrolStepCd: '',
          checkUserId: '',
        }
      }
    },
    colorItems: {
      type: Array,
      default: () => [],
    },
    resultItems: {
      type: Array,
      default: () => [],
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
    currentTab: {
      type: Object,
      default(){
        return {
          saiPatrolPlaceId: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      dialogDetail: false,
      positionDetail: 'bottom',
      selectedRow: {},
      selectedRowIdx: -1,
      dialogpatrolContents: '',
      grid: {
        merge: [
          { index: 0, colName: 'saiEquipClassName' },
          { index: 1, colName: 'groupItemClass' },
        ],
      },
      filter: {
        saiEquipClassName: null,
        saiItemClassName: null,
      },
      lineId: null,
      editable: true,
      detailUrl: '',
      saveUrl: '',
      completeUrl: '',
      cancelUrl: '',
      isSave: false,
      isComplete: false,
      isCancel: false,
      gridColumns: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '100%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    gridHeight() {
      // return String(this.contentHeight - 240) + 'px';
      return '800px';
    },
    disabled() {
      return this.place.patrolPlaceStepCd === 'PPS0000005'
        // || this.patrol.patrolStepCd === 'PS00000010' 
    },
    checker() {
      return this.place.deptName + ' / ' + this.place.userName
    },
    filterData() {
      return this.place.resultMaps.filter(
        data =>
          (!this.filter.saiEquipClassName || data.saiEquipClassName === this.filter.saiEquipClassName) &&
          (!this.filter.saiItemClassName || data.saiItemClassName === this.filter.saiItemClassName)
      )
    },
    equipComboItems() {
      let data = this.$_.uniq(this.$_.map(this.place.resultMaps, 'saiEquipClassName'))
      if (data && data.length > 0) {
        let comboItems = [];
        this.$_.forEach(data, item => {
          comboItems.push({
            code: item,
            codeName: item
          })
        })
        return comboItems;
      } else {
        return [];
      }
    },
    equipFilterData() {
      if (this.filter.saiEquipClassName) {
        return this.$_.filter(this.place.resultMaps, { saiEquipClassName: this.filter.saiEquipClassName })
      } else {
        return this.place.resultMaps;
      }
    },
    itemComboItems() {
      let data = this.$_.uniq(this.$_.map(this.equipFilterData, 'saiItemClassName'))
      if (data && data.length > 0) {
        let comboItems = [];
        this.$_.forEach(data, item => {
          comboItems.push({
            code: item,
            codeName: item
          })
        })
        return comboItems;
      } else {
        return [];
      }
    },
    lineItems() {
      if (this.place && this.place.lines && this.place.lines.length > 0) {
        let items = [];
        this.$_.forEach(this.place.lines, item => {
          items.push({
            lineId: item.lineId,
            lineCd: item.lineCd
          })
        })
        return items;
      } else {
        return [];
      }
    }
  },
  watch: {
    'eventScroll.save'() {
      if (!this.disabled && this.editable && this.currentTab.saiPatrolPlaceId === this.place.saiPatrolPlaceId) {
        this.savePlace();
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.patrol.place.get.url;
      this.saveUrl = transactionConfig.sai.patrol.place.save.url;
      this.completeUrl = transactionConfig.sai.patrol.place.save.url;
      this.cancelUrl = transactionConfig.sai.patrol.place.cancel.url;
      // code setting
          
      this.lineDatachange(true);
      // list setting
    },
    getDetail() {
      if (this.place.saiPatrolPlaceId) {
        this.$http.url = this.$format(this.detailUrl, this.place.saiPatrolPlaceId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.place, _result.data);
        },);
      }
    },
    placeChange() {
      this.place.editFlag = 'U'
    },
    tableDataChange(props, col) {
      let colName = col.name
      /**
       * 요청사항은 테이블 컴포넌트에서 처리됨
       * 
       * 아래의 경우는 라인의 결과값을 변경했을 경우임
       */
      if (colName !== 'patrolContents') {
        if (props.row[colName + 'EditFlag'] !== 'C') {
          props.row[colName + 'EditFlag'] = 'U'
        }
        
      }
    },
    innerBtnClicked(row, btn) {
      this.requestImprRow = row
      let requestContents = row.saiEquipClassName + ' / '
        + row.saiItemClassName + ' / '
        + row.patrolItemName;

      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: row.saiPatrolResultId,
          ibmTaskTypeCd: 'ITT0000065',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '100%';
        this.popupOptions.isFull = '100%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '죽시조치'; // 죽시조치 상세
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: row.saiPatrolResultId,
          ibmTaskTypeCd: 'ITT0000065',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '100%';
        this.popupOptions.isFull = '100%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
              this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
              this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
            this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
              this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
            this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
              this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.getDetail();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;
      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
      }
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (flag !== 'delete') {
          if (result.col1.ibmStepCd === 'IS00000010' || result.col1.ibmStepCd === 'IS00000015' || result.col1.ibmStepCd === 'IS00000020') {
            this.requestImprRow.riskRegisterFlag = true
          }
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitStep[idIndex] = result.col1.ibmStepName;
            this.requestImprRow.ibmStepNames = splitStep.toString();
          }
        } else {
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          let splitClass = this.$_.split(this.requestImprRow.ibmClassCds, ',');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitId.splice(idIndex, 1)
            splitStep.splice(idIndex, 1)
            splitClass.splice(idIndex, 1)
            this.$set(this.requestImprRow, 'sopImprovementIds', splitId.toString())
            this.$set(this.requestImprRow, 'ibmStepNames', splitStep.toString())
            this.$set(this.requestImprRow, 'ibmClassCds', splitClass.toString())
          }
        }

        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.getDetail();
      }
    },
    savePlace() {
      // line 별로 점검이 이루어졌는지?
      // 순회일을 입력했는지?
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.gridColumns, this.place.resultMaps)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.place.chgUserId = this.$store.getters.user.userId
              this.place.editFlag = 'U'
              this.place.results = [];
              this.$_.forEach(this.place.resultMaps, resultMap => {
                let resultLines = [];
                this.$_.forEach(this.place.lines, line => {
                  resultLines.push({
                    saiPatrolResultLineId: resultMap[line.lineId + 'Id'],  // 순회점검 결과별 라인 결과 일련번호
                    saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                    lineId: line.lineId,  // 라인일련번호
                    lineCd: line.lineCd,  // 라인번호
                    patrolLineResultCd: resultMap[line.lineId],  // 점검결과 코드
                    regUserId: this.$store.getters.user.userId,  //
                    chgUserId: this.$store.getters.user.userId,  //
                    editFlag: resultMap[line.lineId + 'EditFlag']
                  })
                });
                this.place.results.push({
                  saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                  saiPatrolPlaceId: this.place.saiPatrolPlaceId,  // 순회점검 결과 장소 일련번호
                  saiPatrolResultItemId: resultMap.saiPatrolResultItemId,  // 순회점검 일련번호
                  patrolItemName: resultMap.patrolItemName,  // 점검항목
                  patrolContents: resultMap.patrolContents,  // 요청내용
                  regUserId: this.$store.getters.user.userId,  //
                  chgUserId: this.$store.getters.user.userId,  //
                  editFlag: resultMap.editFlag,
                  resultLines: resultLines,
                })
              })
              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completePlace() {
      // line 별로 점검이 이루어졌는지?
      // 순회일을 입력했는지?
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.grid.columns, this.place.resultMaps)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.place.editFlag = 'U'
              this.place.chgUserId = this.$store.getters.user.userId
              this.place.patrolPlaceStepCd = 'PPS0000005'
              this.place.results = [];
              this.$_.forEach(this.place.resultMaps, resultMap => {
                let resultLines = [];
                this.$_.forEach(this.place.lines, line => {
                  resultLines.push({
                    saiPatrolResultLineId: resultMap[line.lineId + 'Id'],  // 순회점검 결과별 라인 결과 일련번호
                    saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                    lineId: line.lineId,  // 라인일련번호
                    lineCd: line.lineCd,  // 라인번호
                    patrolLineResultCd: resultMap[line.lineId],  // 점검결과 코드
                    regUserId: this.$store.getters.user.userId,  //
                    chgUserId: this.$store.getters.user.userId,  //
                    editFlag: resultMap[line.lineId + 'EditFlag']
                  })
                });
                this.place.results.push({
                  saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                  saiPatrolPlaceId: this.place.saiPatrolPlaceId,  // 순회점검 결과 장소 일련번호
                  saiPatrolResultItemId: resultMap.saiPatrolResultItemId,  // 순회점검 일련번호
                  patrolItemName: resultMap.patrolItemName,  // 점검항목
                  patrolContents: resultMap.patrolContents,  // 요청내용
                  regUserId: this.$store.getters.user.userId,  //
                  chgUserId: this.$store.getters.user.userId,  //
                  editFlag: resultMap.editFlag,
                  resultLines: resultLines,
                })
              })

              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          this.place.patrolPlaceStepCd === 'PPS0000001'
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (_result.data === 'PS00000010') {
        this.$emit('tranStep')
      } else {
        this.getDetail();
      }
    },
    cancelPlace() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '완료취소 하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.place.chgUserId = this.$store.getters.user.userId

          this.isCancel = !this.isCancel
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    cancelCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.patrol.patrolStepCd = 'PS00000005'
      this.place.patrolPlaceStepCd = 'PPS0000001'
      // if (_result.data === 1) {
      //   this.getDetail();
      // } else {
      //   this.$emit('tranStep')
      // }
    },
    lineDatachange(flag) {
      let defaultCols = [
        {
          name: 'class',
          field: 'class',
          label: '분류',
          child: [
            {
              name: 'saiEquipClassName',
              field: 'saiEquipClassName',
              label: '설비',
              align: 'center',
              sortable: false,
              style: 'width:55px',
            },
            {
              name: 'saiItemClassName',
              field: 'saiItemClassName',
              label: '항목',
              align: 'center',
              sortable: false,
              style: 'width:55px',
            },

          ]
        },
        {
          name: 'patrolItemName',
          field: 'patrolItemName',
          label: '점검항목',
          align: 'left',
          sortable: false,
          style: 'width:150px',
        },
      ];
      let lastCol = [
        {
          name: 'customDetail',
          field: 'customDetail',
          label: '',
          align: 'center',
          type: 'custom',
          style: 'width:40px',
          sortable: false
        },
        // {
        //   name: 'patrolContents',
        //   field: 'patrolContents',
        //   label: '요청사항',
        //   align: 'left',
        //   sortable: false,
        //   style: 'width:150px',
        //   type: 'text',
        // },
        // {
        //   name: 'impr',
        //   field: 'impr',
        //   label: '개선진행',
        //   align: 'center',
        //   child: [
        //     {
        //       name: 'customCol',
        //       field: 'customCol',
        //       label: '개선번호/개선진행상태',
        //       align: 'center',
        //       style: 'width:120px',
        //       type: 'custom',
        //       sortable: false
        //     },
        //   ]
        // },
      ];
      if (this.place && this.place.lines && this.place.lines.length > 0 && this.resultItems && this.resultItems.length > 0) {
        let lines = []
        if (flag) {
          this.lineId = this.place.lines[0].lineId

          lines.push({
            name: this.place.lines[0].lineId,
            field: this.place.lines[0].lineId,
            label: this.place.lines[0].lineCd,
            align: 'center',
            sortable: false,
            style: 'width:35px',
            type: 'select',
            isChip: true,
            none: true,
            comboItems: this.resultItems,
            required: true,
          })
        } else {
          let idx = this.$_.findIndex(this.place.lines, { lineId: this.lineId })
          lines.push({
            name: this.place.lines[idx].lineId,
            field: this.place.lines[idx].lineId,
            label: this.place.lines[idx].lineCd,
            align: 'center',
            sortable: false,
            style: 'width:35px',
            type: 'select',
            isChip: true,
            none: true,
            comboItems: this.resultItems,
            required: true,
          })
        }
        defaultCols.push({
          name: 'line',
          field: 'line',
          label: 'Line',
          align: 'center',
          sortable: false,
          child: lines
        })
      }
      this.gridColumns = this.$_.concat(defaultCols, lastCol)
    },
    rowClickDetail(_row, _idx) {
      this.dialogDetail = true;
      this.selectedRow = _row;
      this.selectedRowIdx = _idx;
      this.dialogpatrolContents = _row.patrolContents;
    },
    dialogClose() {
      this.dialogDetail = false;
    },
    dialogSubmit() {
      this.$set(this.filterData[this.selectedRowIdx], 'patrolContents', this.dialogpatrolContents);
      this.$set(this.filterData[this.selectedRowIdx], 'editFlag', 'U');
      this.$set(this.filterData[this.selectedRowIdx], 'chgUserId', this.$store.getters.user.userId);
      this.dialogDetail = false;
    },
    closePopUps() {
      this.$emit('closePopup')
    },
  }
};
</script>
